import React from 'react'
import CustomInvoicesNew from '../CustomInvoices/CustomInvoices_new'
import { usePosTransactionsStore } from '../../store/PosTransactionsStore'


const Transactions = (props) => {
  const invoiceStore = usePosTransactionsStore()
  
  return (
      <CustomInvoicesNew isPos={true} invoiceStore={invoiceStore} {...props}/>
  )
}

export default Transactions